import React from 'react'
import styled from '@emotion/styled'

import { convertToReadableDate, sortMethods } from 'Helpers'

import GridRow from 'Components/Grid/GridRow'
import Report from 'Components/Report'

const GridRowAlert = styled(GridRow)`
  &:nth-of-type(2n) > * {
    ${({ critical }) => critical && 'background: #e01b1b;'}
    ${({ warning }) => warning && 'background: #444;'}
  }
  &:nth-of-type(2n + 1) > * {
    ${({ critical }) => critical && 'background: #c21717;'}
    ${({ warning }) => warning && 'background: #333;'}
  }
`

const AlertRow = ({ row: alert }) => (
  <>
    <GridRowAlert>
      <div>{alert.patientRef}</div>
      <div>{alert.physician}</div>
      <div>{alert.tCode}</div>
      <div>{alert.journey}</div>
      <div>{alert.responses}</div>
      <div>{alert.trainedByDoctor}</div>
      <div>{alert.confirmedReceipt}</div>
    </GridRowAlert>
  </>
)

const columns = [
  { header: 'Patient', property: 'patientRef' },
  { header: 'Physician', property: 'physician' },
  { header: 'T-Code', property: 'tCode' },
  { header: 'Journey', property: 'journey', size: '2x' },
  { header: 'Responses', property: 'responses', sort: sortMethods.number },
  { header: 'Confirmed Receipt', property: 'confirmedReceipt' },
  { header: 'Trained By Doctor', property: 'trainedByDoctor' }
]

export default ({ report }) => (
  <Report
    id="device"
    report={report}
    columns={columns}
    ReportRow={AlertRow}
    defaultSortIndex={0}
    prop="journeys"
  />
)
